import Firebase from "firebase"

export const CHARGE_ENDPOINT =
  process.env.NODE_ENV === "development"
    ? "https://6cx8vyk5ag.execute-api.us-west-2.amazonaws.com/prod/chargetest"
    : "https://6cx8vyk5ag.execute-api.us-west-2.amazonaws.com/prod/charge"
export const SESSION_ENDPOINT =
  "https://6cx8vyk5ag.execute-api.us-west-2.amazonaws.com/prod/sessionManager"
export const SETTINGS_ENDPOINT =
  "https://6cx8vyk5ag.execute-api.us-west-2.amazonaws.com/prod/dashboardupdate"
export const REFRESH_AVATAR_ENDPOINT =
  "https://6cx8vyk5ag.execute-api.us-west-2.amazonaws.com/prod/publicrefreshavatar"
export const INVOICES_ENDPOINT =
  "https://us-central1-slackchatv1.cloudfunctions.net/loadInvoices"

export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyC4SWpCB4z3jhs9i-KJ6X4Cy5A06ym8PZU",
  authDomain: "slackchatv1.firebaseapp.com",
  databaseURL: "https://slackchatv1.firebaseio.com",
  storageBucket: "slackchatv1.appspot.com",
  messagingSenderId: "1085786316412",
}

export const firebase = Firebase.initializeApp(FIREBASE_CONFIG)

// messenger config

export const LAUNCHER_TYPES = {
  BUTTON: "button",
  ICON: "icon",
  TAB: "tab",
}

export const TRIGGER_TYPES = {
  TIME_ON_PAGE: 0,
  PAGE_VIEWS: 1,
  MATCH_URL: 2,
}

export const MATCH_TYPES = {
  STARTS_WITH: 0,
  INCLUDES: 1,
  EXACTLY: 2,
}

export const AVATAR_CONFIG = {
  USER: 0,
  TEAM: 1,
}



// WEBPACK FOOTER //
// ./src/app/constants.js